import { myFleetActions } from "./myFleet.slice";
import axiosHttp from "../../services/interceptor";
import { emitToasterMsg } from "../../services/toasterUtility";

const baseURL = process.env.REACT_APP_BASE_URL;

const getDropdownData = async (entity) => {
	try {
		const response = await axiosHttp.get(
			`${baseURL}api/MasterData/${entity}`
		);
		return { [entity]: response?.data };
	} catch (error) {
		console.error(error.message);
	}
};


export const getMasterData = () => async (dispatch, getState) => {
	try {
		const response = await Promise.all([
			getDropdownData("GetRiskAssessment"),
			getDropdownData("GetImoVesselType"),
			getDropdownData("GetMrvVesselType"),
			getDropdownData("GetIceClasses"),
			getDropdownData("GetTechnicalEfficiency"),
			getDropdownData("GetMonitoringMethod"),
			getDropdownData("GetConsumerMonitoringMethod"),
			getDropdownData("GetMrvConsumerMonitoringMethod"),
			getDropdownData("GetEmissionSourceType"),
			getDropdownData("GetEmissionSourceClass"),
			getDropdownData("GetUKETSMonitoringMethod")
		]);
		dispatch(myFleetActions.setMasterData({ masterData: response }));
		return response;
	} catch (error) {
		emitToasterMsg("error", "Error", error?.message);
	}
};


